import {
    ADD_AWARD_REQUEST,
    ADD_AWARD_SUCCESS,
    ADD_AWARD_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const addAwardReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_AWARD_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case ADD_AWARD_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case ADD_AWARD_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default addAwardReducer;
